import { queryCategoryItems } from 'lowcomp/plugins/blog/common/blog-api/queryCategoryItems';
import { ItfAPIParams } from './type';

export const getAPIData = async (params: ItfAPIParams, locale: string) => await queryCategoryItems(locale, params);
